// extracted by mini-css-extract-plugin
module.exports = {"main--loading":"Pagination_main--loading__q7C11"};